import { render, staticRenderFns } from "./CalendarWeekLabel.vue?vue&type=template&id=507cd499&"
import script from "./CalendarWeekLabel.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarWeekLabel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507cd499')) {
      api.createRecord('507cd499', component.options)
    } else {
      api.reload('507cd499', component.options)
    }
    module.hot.accept("./CalendarWeekLabel.vue?vue&type=template&id=507cd499&", function () {
      api.rerender('507cd499', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/DatePicker/components/CalendarWeekLabel.vue"
export default component.exports